module.exports = __webpack_public_path__ + "img/success_OLD_7.ff326b27.gif";